exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popover-demo-content[data-v-4a4a7841]{padding:5px 10px}", ""]);

// exports
